import RouterContext from './RouterContext'

export default RouterContext.Consumer
